import actionCreatorFactory from 'typescript-fsa'
import { FavouriteDeal } from './types'

const actionCreator = actionCreatorFactory('ACCOUNT')

const signIn = actionCreator<{username: string, email: string, favDeals: FavouriteDeal[]}>('SIGN_IN')
const signOut = actionCreator('SIGN_OUT')

export {
    signIn,
    signOut,
}
